/**
 * Design Tokens (Auto-generated from design-tokens.json)
 * DO NOT EDIT MANUALLY - Run 'npm run generate:tokens' to regenerate
 *
 * This file is automatically generated from the root design-tokens.json
 * which serves as the single source of truth for design values across
 * the frontend, backend, and email templates.
 */

export const tokens = {
  colors: {
    brand: {
      primary: '#357161',
      primaryDark: '#2D5A4E',
      primaryHover: '#2D5A4E',
      primaryLight: '#52A690',
      secondary: '#E9A7B3',
      secondaryDark: '#D18898',
      secondaryLight: '#F0C1CA',
      link: '#357161',
      primaryOverlayLight: 'rgba(53, 113, 97, 0.05)',
      primaryOverlay: 'rgba(53, 113, 97, 0.1)',
      primaryOverlayMedium: 'rgba(53, 113, 97, 0.2)',
      secondaryOverlay: 'rgba(233, 167, 179, 0.1)',
      secondaryOverlayMedium: 'rgba(233, 167, 179, 0.2)',
      gradientEnd: '#1a2742',
    },
    background: {
      canvas: '#F6EEE3',
      content: '#FFFFFF',
      secondary: '#F8F9FA',
      disabled: '#F0F2F5',
      surface: '#FFFFFF',
      surfaceSecondary: '#F8F9FA',
      skeleton: '#e0e5e3',
      skeletonHighlight: '#f0f3f2',
    },
    text: {
      primary: '#004F3E',
      secondary: '#356D5F',
      tertiary: '#7A9B91',
      placeholder: '#A8BCB5',
      inverse: '#FFFFFF',
    },
    button: {
      primary: '#357161',
      primaryHover: '#2D5A4E',
      primaryText: '#FFFFFF',
      secondary: '#E9A7B3',
      secondaryHover: '#D18898',
      secondaryText: '#004F3E',
      tertiary: '#E3DED1',
      danger: '#C62828',
      dangerHover: '#A02020',
      disabled: '#E3E6EA',
      disabledText: '#8A949E',
      disabledBorder: '#D2D7DD',
    },
    semantic: {
      success: '#4caf50',
      successStrong: '#2E7D32',
      successDark: '#2e7d32',
      successLight: '#e8f5e9',
      successLightBorder: '#c8e6c9',
      successBackground: 'rgba(76, 175, 80, 0.1)',
      successBackgroundSubtle: 'rgba(76, 175, 80, 0.08)',
      successBackgroundMedium: 'rgba(76, 175, 80, 0.2)',
      error: '#C62828',
      errorLight: '#fce8e6',
      errorBackground: 'rgba(198, 40, 40, 0.1)',
      errorBackgroundSubtle: 'rgba(198, 40, 40, 0.08)',
      errorFocusRing: 'rgba(198, 40, 40, 0.2)',
      warning: '#ED8B00',
      warningStrong: '#B34700',
      warningDark: '#e65100',
      warningText: '#B34700',
      warningLight: '#fff3e0',
      warningBackground: 'rgba(237, 139, 0, 0.1)',
      warningBackgroundSubtle: 'rgba(237, 139, 0, 0.05)',
      info: '#1976D2',
      infoText: '#0D47A1',
      infoLight: '#e8f0fe',
      infoBackground: 'rgba(25, 118, 210, 0.1)',
      muted: '#546e7a',
      mutedBackground: 'rgba(96, 125, 139, 0.1)',
      mutedBackgroundMedium: 'rgba(96, 125, 139, 0.2)',
    },
    admin: {
      gradientStart: '#1e293b',
      gradientEnd: '#0f172a',
    },
    code: {
      background: '#1e1e1e',
      text: '#d4d4d4',
    },
    border: {
      default: '#D4DDD9',
      input: '#B8C9C3',
      inputFocus: '#44917B',
      inputError: '#E9A7B3',
    },
    overlay: {
      modal: 'rgba(0, 0, 0, 0.5)',
      tableHover: 'rgba(0, 0, 0, 0.04)',
      hover: 'rgba(0, 0, 0, 0.05)',
      hoverSubtle: 'rgba(0, 0, 0, 0.03)',
      scrollEdge: 'rgba(0, 0, 0, 0.12)',
      dark: 'rgba(0, 0, 0, 0.4)',
      darkStrong: 'rgba(0, 0, 0, 0.7)',
      light: 'rgba(255, 255, 255, 0.1)',
      extraLight: 'rgba(255, 255, 255, 0.05)',
      onDark: 'rgba(255, 255, 255, 0.2)',
      onDarkStrong: 'rgba(255, 255, 255, 0.3)',
      onDarkText: 'rgba(255, 255, 255, 0.8)',
    },
    speaker: {
      speaker1: '#44917B',
      speaker1Background: 'rgba(53, 113, 97, 0.1)',
      speaker1Border: '#44917B',
      speaker2: '#6B8A3D',
      speaker2Background: 'rgba(107, 138, 61, 0.1)',
      speaker2Border: '#6B8A3D',
      speaker3: '#7B5D9A',
      speaker3Background: 'rgba(123, 93, 154, 0.1)',
      speaker3Border: '#7B5D9A',
      speaker4: '#C47B32',
      speaker4Background: 'rgba(196, 123, 50, 0.1)',
      speaker4Border: '#C47B32',
    },
    appointment: {
      client: '#44917B',
      private: '#7A9B91',
      internal: '#E9A7B3',
    },
    appointmentType: {
      red: '#D32F2F',
      redLight: '#E57373',
      orange: '#EF6C00',
      orangeLight: '#FFAB91',
      amber: '#F9A825',
      amberLight: '#FFD54F',
      green: '#2E7D32',
      greenLight: '#81C784',
      teal: '#00897B',
      tealLight: '#80CBC4',
      blue: '#1565C0',
      blueLight: '#64B5F6',
      purple: '#6A1B9A',
      purpleLight: '#BA68C8',
      pink: '#C2185B',
      pinkLight: '#F48FB1',
    },
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
  },
  sizing: {
    touchTargetMin: '44px',
    controlHeight: '40px',
    fieldShort: '16rem',
    fieldMedium: '28rem',
  },
  spacing: {
    none: '0',
    '2xs': '2px',
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    '2xl': '32px',
    '3xl': '48px',
    '4xl': '64px',
    '5xl': '96px',
  },
  typography: {
    fontFamily: {
      sans: '"Saira", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      base: '"Saira", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      mono: '"SF Mono", "Monaco", "Cascadia Code", "Roboto Mono", "Courier New", monospace',
    },
    fontSize: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      '2xl': '24px',
      '3xl': '30px',
      '4xl': '36px',
      '5xl': '48px',
    },
    fontWeight: {
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
    },
    lineHeight: {
      tight: '1',
      snug: '1.25',
      normal: '1.5',
      relaxed: '1.75',
      loose: '2',
    },
  },
  borderRadius: {
    none: '0',
    sm: '2px',
    base: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
    '2xl': '16px',
    '3xl': '24px',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    focus: '0 0 0 3px rgba(53, 113, 97, 0.3)',
    focusError: '0 0 0 3px rgba(198, 40, 40, 0.2)',
  },
  transitions: {
    duration: {
      instant: '75ms',
      fast: '150ms',
      normal: '200ms',
      moderate: '300ms',
      slow: '500ms',
    },
    easing: {
      linear: 'linear',
      ease: 'ease',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      spring: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    },
    property: {
      all: 'all',
      colors: 'color, background-color, border-color',
      opacity: 'opacity',
      transform: 'transform',
      shadow: 'box-shadow',
    },
  },
  breakpoints: {
    xxs: '360px',
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
  },
  opacity: {
    busy: '0.6',
  },
  zIndex: {
    behind: '-1',
    base: '0',
    dropdown: '10',
    sticky: '20',
    fixed: '30',
    overlay: '40',
    modal: '50',
    popover: '60',
    toast: '70',
    max: '9999',
  },
} as const

export type Tokens = typeof tokens

// Convenience exports for common token categories
export const colors = tokens.colors
export const spacing = tokens.spacing
export const typography = tokens.typography
export const borderRadius = tokens.borderRadius
export const shadows = tokens.shadows
export const transitions = tokens.transitions
export const breakpoints = tokens.breakpoints
export const zIndex = tokens.zIndex
